<template>
  <li v-if="macroList.length">
    <span variant="default" class="dropdown-item">
      <b-icon-list /> {{label}}
    </span>

    <ul class="menu_list">
      <li
        v-for="(item, index) in macroList"
        :key="`macros_${index}`"
      >
      <button class="btn btn-default btn-block"  @click.prevent="onMacroCall(item.name)">
      <span class="d-flex">
        <b-icon-arrow-return-right />
        <span>{{ item.label }}</span>
      </span>
      </button>
      </li>
    </ul>
  </li>
</template>

<script>
import { props } from "./props";
import { methods } from "./methods";
export default {
  name: "macro-menu-options",
  props,
  methods,
  data() {
    return {
      checked: false,
    };
  },
};
</script>

<style scoped>
.menu_list{list-style: none; padding: 0 15px; margin: 0;}
</style>